import { ApiService } from '../../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigSectionService {
  constructor(private apiService: ApiService) {
  }

  GetFields() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBSections')
      .map(
      data => {
        return data;
      }
      );
  }

  GetSectionById(sectionGUID) {
    return this.apiService.get('/api/mvp/dfb/get/DFBSection/?id=' + sectionGUID)
      .map(
      data => {
        return data;
      }
      );
  }

  GetGroups() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBGroups')
      .map(
      data => {
        return data;
      }
      );
  }

  GetTabs() {
    return this.apiService.get('/api/mvp/dfb/get/tabs')
      .map(
      data => {
        return data;
      }
      );
  }

  AddSection(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/add/section', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "e";
      }
      );
  }
  EditSection(agencyObj) {
    return this.apiService.post('/api/mvp/edit/dfbSection', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "e";
      }
      );
  }


}





// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configure_section/section.service.ts